import React from "react";
import OtpModule from "../../OtpModule";

const OtpForm = ({
  phoneNumber,
  handleOtpSubmit,
  sendOtp,
  otpLoading,
  otpError,
  setOtpError,
  handleEditPhoneNumber,
}) => {
  return (
    <div className="w-full flex flex-col justify-start">
      <OtpModule
        phone={phoneNumber}
        handleSubmit={handleOtpSubmit}
        sendOtp={() => sendOtp(phoneNumber)}
        loading={otpLoading}
        otpError={otpError}
        clearOtpError={() => setOtpError && setOtpError("")}
      />
      <button
        type="button"
        onClick={handleEditPhoneNumber}
        className="mt-6 text-sm font-bold text-[#009DFF] hover:underline block mx-auto cursor-pointer"
      >
        ← Edit Phone Number
      </button>
    </div>
  );
};

export default OtpForm;
